import { render } from "./PhoneNumberField.vue?vue&type=template&id=f59fe4fc"
import script from "./PhoneNumberField.vue?vue&type=script&lang=js"
export * from "./PhoneNumberField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PhoneNumberField.vue"]])

export default __exports__